import adminApiFetch from './apiService';

const importTemplateService = {
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('import_templates/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  getIds: async (params = {}) => {
    const res = await adminApiFetch('import_templates/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.import_type) queryParams.append('import_type', params.import_type);

    const res = await adminApiFetch(`import_templates?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  get: async (id) => {
    const res = await adminApiFetch(`import_templates/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  create: async (data) => {
    const res = await adminApiFetch('import_templates', {
      method: 'POST',
      body: { import_template: data }
    });
    return res.json();
  },

  update: async (id, data) => {
    const res = await adminApiFetch(`import_templates/${id}`, {
      method: 'PUT',
      body: { import_template: data }
    });
    return res.json();
  },

  delete: async (id) => {
    const res = await adminApiFetch(`import_templates/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  getSchemaFields: async (importType) => {
    const res = await adminApiFetch(`import_templates/schema_fields?import_type=${importType}`, {
      method: 'GET'
    });
    return res.json();
  }
};

export { importTemplateService };
export default importTemplateService;
